/** @format */

import { DeepPartial } from "@reduxjs/toolkit";
import {
  Lesson,
  Resource,
  ResourceObject,
} from "../../../features/resources/types";
import { api } from "../api";

export const lessonApi = api.injectEndpoints({
  endpoints: (build) => ({
    getResourceLesson: build.query<
      Lesson,
      { resourceId: string; lessonIndex: number; lessonUUID: string }
    >({
      query: ({ resourceId }) => `resource/${resourceId.toLocaleLowerCase()}`,
      transformResponse: (
        response: { Object: ResourceObject },
        meta: undefined,
        { lessonIndex },
      ) => response?.Object?.lessons?.[lessonIndex],
      providesTags: (results, err, { lessonUUID }) => [
        { type: "SubLesson", id: lessonUUID },
      ],
    }),

    updateLesson: build.mutation<
      { message: string },
      { diff: DeepPartial<Resource>; primaryKey: { PK: string; SK: string } }
    >({
      query(body) {
        return {
          url: "resource/save-resource",
          method: "POST",
          body,
          credentials: "include",
        };
      },
      invalidatesTags: ["Resource", "SubLesson", "Card"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetResourceLessonQuery, useUpdateLessonMutation } = lessonApi;
